import { axiosSwagger } from "@/axios";

export const state = {
    myPostPool: {
        loading: false,
        data: [],
        total: 0,

        selectedIndex: null,
    },
    availablePostPool: {
        loading: false,
        data: [],
        total: 0,

        selectedIndex: null,
    },
    pagination: {
        grid: {
          start: 0,
          limit: 0,
        }
    }
}


export const getters = {
}


export const mutations = {
    // MY POOL
    myPostPoolLoading: (state, loading) => {
        state.myPostPool.loading = loading;
    },
    setMyPostPoolData: (state, data) => {
        state.myPostPool.data = data;
    },
    setMyPostPoolTotal: (state, total) => {
        state.myPostPool.total = total;
    },
    addMyPostPool: (state, data) => {
        state.myPostPool.data.push(data);
    },
    removeMyPostPool: (state, id) => {
        state.myPostPool.data = state.myPostPool.data.filter((el) => el.id !== id);
    },
    updateMyPostPool: (state, data) => {
        const index = state.myPostPool.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.myPostPool.data[index].title = data.title;
            state.myPostPool.data[index].description = data.description;
            state.myPostPool.data[index].downloadable = data.downloadable;
            state.myPostPool.data[index].allowOtherUserToAddFiles = data.allowOtherUserToAddFiles;
        }
    },
    setMyPostPoolIndex: (state, index) => {
        state.myPostPool.selectedIndex = index;
    },
    // AVAILABLE POOL
    availablePostPoolLoading: (state, loading) => {
        state.availablePostPool.loading = loading;
    },
    setAvailablePostPoolData: (state, data) => {
        state.availablePostPool.data = data;
    },
    setAvailablePostPoolTotal: (state, total) => {
        state.availablePostPool.total = total;
    },
    setAvailablePostPoolIndex: (state, index) => {
        state.availablePostPool.selectedIndex = index;
    },
    // pagination GRID
    setPaginationGridStart: (state, data) => {
        state.pagination.grid.start = data;
    },
    setPaginationGridLimit: (state, data) => {
        state.pagination.grid.limit = data;
    },
}


export const actions = {
    // GET POST POOL BY ID
    // eslint-disable-next-line no-unused-vars
    async readPostPoolById({ commit }, id) {
        return await axiosSwagger
        .get(`/api/PostPool/${id}`)
        .then((response) => {
        
            return response;
        });
    },
    // MY POST POOL
    async readMyPostPool({ commit }) {
        commit("myPostPoolLoading", true);

        return await axiosSwagger
        .get("/api/PostPool/My")
        .then((response) => {
            commit("setMyPostPoolData", response.data);
            commit("setMyPostPoolTotal", response.data.length);
            commit("myPostPoolLoading", false);

            return response;
        })
        .catch(() => {
            commit("myPostPoolLoading", false);
        });
    },
    // AVAILABLE  POST POOL 
    async readAvailablePostPool({ commit }) {
        commit("availablePostPoolLoading", true);

        return await axiosSwagger
        .get("/api/PostPool/Available")
        .then((response) => {
            commit("setAvailablePostPoolData", response.data);
            commit("setAvailablePostPoolTotal", response.data.length);
            commit("availablePostPoolLoading", false);

            return response;
        })
        .catch(() => {
            commit("availablePostPoolLoading", false);
        });
    },
    async createPostPool({ commit }, data) {
        return await axiosSwagger
        .post(`/api/PostPool`, data)
        .then((response) => {
            commit("addMyPostPool", response.data);

            return response;
        });
    },
    async deletePostPool({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/PostPool/${id}`)
        .then((response) => {
            commit("removeMyPostPool", id);

            return response;
        });
    },
    async updatePostPool({ commit }, data) {
        return await axiosSwagger
        .put(`/api/PostPool/${data.id}`, data)
        .then((response) => {
            commit("updateMyPostPool", data);

            return response;
        });
    },
}